import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { BsInfoCircle } from 'react-icons/bs'

type InfoPopoverProps = {
    title: string;
    content: string;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({ title, content }) => {
    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3" className='fw-bold'>{title}</Popover.Header>
            <Popover.Body>
                {content}
            </Popover.Body>
        </Popover>
    )

    return (
        <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={popover}
        >
            <span tabIndex={0}>         
                   <BsInfoCircle className='ms-2' />
                   </span>

        </OverlayTrigger>
    )
}

export default InfoPopover